export const getFormSteps = (form)=>{
    const steps = form?.steps?.filter((step)=>!step.hidden && step.layout?.large?.items?.length).map((step)=>({
            id: step.id,
            name: step.name
        }));
    return steps;
};

//# sourceMappingURL=get-form-steps.js.map